import React from 'react';
import Image from '../../../img/MainWebsite/ForHotels.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function ForHotels() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent  whiteFont'}>
        <div className={'column'}>
          <h2 className={'left blue'}>PRESENT YOUR OFFERINGS THE WAY THEY DESERVE </h2>
          <h5 className={'left'}>Designed for Hotels & Resorts:   </h5>
          <ul className={"two-columns"}>
            <li className={'blue left'}><h5>Supplements printed menus—never replaces them  </h5></li>
            <li className={'blue left'}><h5>Accessible on guests’ own phones or tablets </h5></li>
            <li className={'blue left'}><h5>Showcases dining, bar, room service, pool, spa, and resort amenities </h5></li>
            <li className={'blue left'}><h5>Supports staff and reduces pressure on food & beverage, front desk, and management  </h5></li>
            <li className={'blue left'}><h5>Generates an additional revenue stream </h5></li>
            <li className={'blue left'}><h5>No investment, no setup fees, no hardware, no training, no downloads, and no financial risk </h5></li>
            <li className={'blue left'}><h5>Exclusively branded for your property </h5></li>
          </ul>

          <h5 className={'left'}>Your hotel or resort invests significant time, creativity, and intention into delivering a premium guest experience 
across every touchpoint. Your menus and amenity offerings should reflect that same level of care—setting 
expectations, guiding choices, and enhancing the overall stay. </h5>
          <h5 className={'left'}>Vizo Menu provides a supplemental digital platform that enhances—rather than replaces—your existing menus 
and printed materials. Accessible on guests’ own phones or tablets, it clearly and consistently presents your 
dining, bar, room service, poolside, and resort offerings through vivid imagery, thoughtful descriptions, key 
details, and critical allergy or dietary notes, all while complementing your current service model.  </h5>
          <h5 className={'left'}>Designed specifically for hotel and resort environments, Vizo Menu allows guests to explore offerings at their 
own pace, often before staff interaction. By answering common questions upfront, it supports food & beverage 
teams, reduces repetitive inquiries at the front desk and concierge, and eases pressure on management during 
peak periods—resulting in smoother operations and a more confident, informed guest. </h5>
          <h5 className={'left'}>Hotels and resorts can strengthen engagement and introduce an additional revenue stream through carefully 
integrated sponsorships that align with the guest experience—without clutter, disruption, or overt advertising. </h5>
          <h5 className={'left'}>Vizo Menu is intentionally designed to stay out of the way. The experience is exclusively branded for your 
property, ensuring guests engage only with your offerings, your style, and your brand. </h5>
          <h5 className={'left'}>Best of all, Vizo Menu is provided at no investment. Our model allows us to deliver this enhancement with no 
setup fees, no hardware, no training, no downloads, and no financial risk—making it a simple, low-risk way to 
elevate how your hotel or resort presents what it offers. </h5>
          <h5 className={'blue left italic'}>Your property. Your offerings. Presented with the clarity and care they deserve. 
</h5>
        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background blue-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ForHotels;